import React, { createContext, useContext } from "react";

export const ThemeSwitchingContext = createContext(null);

export const useThemeSwitchingContext = () => {
  const value = useContext(ThemeSwitchingContext);
  if (!value) {
    throw new Error(
      "useThemeSwitchingContext must be used within ThemeSwitchingContext.Provider"
    );
  }
  return value;
};

export const ThemeSwitchingProvider = ({ value, children }) => (
  <ThemeSwitchingContext.Provider value={value}>
    {children}
  </ThemeSwitchingContext.Provider>
);
